// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.layered {
  box-shadow: 0 0.1rem 0.3rem rgba(0, 0, 0, 0.12), 0 0.1rem 0.2rem rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.layered-3 {
  box-shadow: 0 0.3rem 0.6rem rgba(0, 0, 0, 0.16), 0 0.3rem 0.6rem rgba(0, 0, 0, 0.23);
}

.dropdown-toggle .caret {
  vertical-align: super;
  margin-left: 0.5rem;
}

#artful-client .dropdown-menu {
  z-index: 4000;
}

.drop-right {
  float: right !important;
  position: relative !important;
  left: 100% !important;
  top: -2.5rem !important;
}

.dropdown-menu > li > span,
.dropdown-menu > li > div span {
  display: block;
  padding: 0.3rem 1rem;
  clear: both;
  font-weight: normal;
  line-height: 1.42857143;
  color: #333;
  white-space: nowrap;
  cursor: pointer;
}

nav.navbar {
  margin-bottom: 0;
}

.navbar-header .navbar-brand {
  float: left;
  height: 5rem;
  padding: 0.5rem 0 0 0;
  font-size: 1.8rem;
  cursor: pointer;
}
.navbar-header .navbar-brand img {
  max-height: 100%;
}

nav.navbar-inverse {
  z-index: inherit; /*navbar-static-top*/
  box-shadow: none; /*layered*/
  background: none; /*navbar-default*/
  background-color: none;
  border: none;
}
nav.navbar-inverse .fa {
  color: #fff;
}

.navbar.layered.navbar-default.navbar-static-top {
  z-index: 4000;
}

#artful-client .navbar {
  position: relative;
  width: 100%;
  border: 0;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.12);
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 4000;
}
@media (max-width: 768px) {
  #artful-client .navbar {
    background-color: rgba(255, 255, 255, 0.95);
  }
}
#artful-client .navbar .navbar-header {
  float: none;
  text-align: center;
  height: 6rem;
}
#artful-client .navbar .navbar-header .navbar-brand {
  height: 6rem;
  float: none;
  display: inline-block;
  padding: 0.8rem 0;
}
@media (max-width: 768px) {
  #artful-client .navbar .navbar-header .navbar-brand {
    position: absolute;
    left: 0.9rem;
  }
}
#artful-client .navbar .navbar-header .navbar-toggle {
  float: none;
  position: absolute;
  right: 0;
  top: 0.6rem;
}
#artful-client .navbar .navbar-header .navbar-current {
  height: 6rem;
  padding: 0.8rem 0;
  font-size: 2rem;
  text-transform: uppercase;
  display: none;
  align-items: center;
  justify-content: center;
}
@media (max-width: 768px) {
  #artful-client .navbar .navbar-header .navbar-current {
    display: flex !important;
  }
}
#artful-client .navbar .navbar-header .navbar-current__month, #artful-client .navbar .navbar-header .navbar-current__day {
  padding-right: 0.5rem;
  font-weight: 600;
}
#artful-client .navbar .navbar-collapse {
  background: #f8f8f8;
}
@media (min-width: 1024px) {
  #artful-client .navbar .navbar-collapse {
    position: absolute;
    top: 0;
    right: 11.5rem;
    background: transparent;
  }
}
@media (max-width: 1023px) and (min-width: 600px) {
  #artful-client .navbar .navbar-collapse {
    position: absolute;
    top: 0;
    right: 4rem;
    background: transparent;
  }
}
#artful-client .navbar .navbar-collapse .navbar-right {
  margin-right: 0;
}
#artful-client .navbar .navbar-mobile-calendar .header-buttons {
  display: none;
}
#artful-client .navbar .navbar-mobile-calendar .open-date-picker .react-datepicker {
  border: 0;
  font-size: 2rem;
  background: transparent;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
#artful-client .navbar .navbar-mobile-calendar .open-date-picker .react-datepicker__day {
  font-size: 2rem;
  width: 1.5em;
  line-height: 1.5em;
}
#artful-client .navbar .navbar-mobile-calendar .open-date-picker .react-datepicker__day:hover {
  background: transparent;
  color: black;
}
#artful-client .navbar .navbar-mobile-calendar .open-date-picker .react-datepicker__day:hover:before {
  background: transparent;
}
#artful-client .navbar .navbar-mobile-calendar .open-date-picker .react-datepicker__header {
  display: none;
}
#artful-client .navbar .navbar-mobile-calendar .open-date-picker .react-datepicker__current-month {
  font-size: 2rem;
}
#artful-client .navbar .navbar-mobile-calendar .open-date-picker .react-datepicker__navigation--next:after, #artful-client .navbar .navbar-mobile-calendar .open-date-picker .react-datepicker__navigation--previous:after {
  padding: 1.6rem;
}
#artful-client .navbar .navbar-mobile-calendar .open-date-picker .react-datepicker__navigation--previous {
  left: -4rem;
  top: calc(50% - 2.4rem);
}
#artful-client .navbar .navbar-mobile-calendar .open-date-picker .react-datepicker__navigation--next {
  right: -4rem;
  top: calc(50% - 2.4rem);
}

#artful-client .navbar-default .navbar-toggle {
  border: 0;
  margin: 0;
  padding: 1.7rem 0.9rem;
}
#artful-client .navbar-default .navbar-toggle:focus, #artful-client .navbar-default .navbar-toggle:hover {
  background: none;
}
#artful-client .navbar-default .navbar-toggle:focus .icon-bar, #artful-client .navbar-default .navbar-toggle:hover .icon-bar {
  background-color: #dabc64;
}
#artful-client .navbar-default .navbar-toggle .icon-bar {
  width: 1.8rem;
  border-radius: 0;
  height: 0.2rem;
  background-color: rgba(0, 0, 0, 0.7);
}
#artful-client .navbar-default .navbar-toggle .icon-bar + .icon-bar {
  margin-top: 0.5rem;
}

#artful-client .navbar-nav > li > a {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  height: 5.8rem;
  line-height: 2.8rem;
}

#artful-client .navbar-nav .dropdown-toggle:focus {
  outline: revert;
}

.artful-plus-new-icon-div {
  display: inline-block;
}

.artful-plus-nav-link {
  display: flex !important;
}

.artful-plus-new-icon {
  height: 20px !important;
  margin-left: 11px;
  cursor: pointer;
  position: relative;
}

svg#artful-plus-new-icon g path,
svg#artful-plus-new-icon path {
  fill: rgb(171, 58, 114) !important;
}

.artful-plus-new-text {
  position: absolute;
  top: 50%;
  left: 65%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 9px;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Layout/ApplicationNavigation/ApplicationNavigation.scss","webpack://./src/Styles/Variables.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AAGA;EACE,oFAAA;EACA,qDAAA;AAAF;;AAEA;EACE,oFAAA;AACF;;AAGE;EACE,qBAAA;EACA,mBAAA;AAAJ;;AAIA;EAEE,aCQS;ADVX;;AAKA;EACE,uBAAA;EACA,6BAAA;EACA,qBAAA;EACA,uBAAA;AAFF;;AAKA;;EAEE,cAAA;EACA,oBAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;AAFF;AAGE;EACE,gBAAA;AADJ;;AAKA;EACE,gBAAA,EAAA,oBAAA;EACA,gBAAA,EAAA,UAAA;EACA,gBAAA,EAAA,iBAAA;EACA,sBAAA;EACA,YAAA;AAFF;AAGE;EACE,WAAA;AADJ;;AAKA;EACE,aCzCS;ADuCX;;AAME;EAEE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,6CAAA;EACA,0CAAA;EACA,aCpDO;ADgDX;AAMI;EATF;IAUI,2CAAA;EAHJ;AACF;AAKI;EACE,WAAA;EACA,kBAAA;EACA,YAxFU;AAqFhB;AAKM;EACE,YA3FQ;EA4FR,WAAA;EACA,qBAAA;EACA,iBAAA;AAHR;AAKQ;EANF;IAOI,kBAAA;IACA,YAAA;EAFR;AACF;AAKM;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;AAHR;AAMM;EACE,YA9GQ;EA+GR,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAJR;AAMQ;EATF;IAUI,wBAAA;EAHR;AACF;AAKQ;EAEE,qBAAA;EACA,gBAAA;AAJV;AASI;EACE,mBAAA;AAPN;AASM;EAHF;IAII,kBAAA;IACA,MAAA;IACA,cAAA;IACA,uBAAA;EANN;AACF;AAQM;EAVF;IAWI,kBAAA;IACA,MAAA;IACA,WAAA;IACA,uBAAA;EALN;AACF;AAOM;EACE,eAAA;AALR;AAUM;EACE,aAAA;AARR;AAWM;EACE,SAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;AATR;AAWQ;EACE,eAAA;EACA,YAAA;EACA,kBAAA;AATV;AAWU;EACE,uBAAA;EACA,YAAA;AATZ;AAWY;EACE,uBAAA;AATd;AAcQ;EACE,aAAA;AAZV;AAeQ;EACE,eAAA;AAbV;AAgBQ;EAEE,eAAA;AAfV;AAkBQ;EACE,WAAA;EACA,uBAAA;AAhBV;AAmBQ;EACE,YAAA;EACA,uBAAA;AAjBV;;AAwBA;EACE,SAAA;EACA,SAAA;EACA,sBAAA;AArBF;AAuBE;EAEE,gBAAA;AAtBJ;AAuBI;EACE,yBDrMY;ACgLlB;AAyBE;EACE,aAAA;EACA,gBAAA;EACA,cAAA;EACA,oCAAA;AAvBJ;AAyBI;EACE,kBAAA;AAvBN;;AA4BA;EACE,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;AAzBF;;AA4BA;EACE,eAAA;AAzBF;;AA4BA;EACE,qBAAA;AAzBF;;AA4BA;EACE,wBAAA;AAzBF;;AA4BA;EACE,uBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AAzBF;;AA4BA;;EAEE,kCAAA;AAzBF;;AA4BA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;AAzBF","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import 'Colors.scss';\n@import 'Variables.scss';\n\n$navbar-height: 6rem;\n\n.layered {\n  box-shadow: 0 0.1rem 0.3rem rgba(0, 0, 0, 0.12), 0 0.1rem 0.2rem rgba(0, 0, 0, 0.24);\n  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n}\n.layered-3 {\n  box-shadow: 0 0.3rem 0.6rem rgba(0, 0, 0, 0.16), 0 0.3rem 0.6rem rgba(0, 0, 0, 0.23);\n}\n\n.dropdown-toggle {\n  .caret {\n    vertical-align: super;\n    margin-left: 0.5rem;\n  }\n}\n\n#artful-client .dropdown-menu {\n  //max-height: 100%;\n  z-index: $navLayer;\n}\n\n.drop-right {\n  float: right !important;\n  position: relative !important;\n  left: 100% !important;\n  top: -2.5rem !important;\n}\n\n.dropdown-menu > li > span,\n.dropdown-menu > li > div span {\n  display: block;\n  padding: 0.3rem 1rem;\n  clear: both;\n  font-weight: normal;\n  line-height: 1.42857143;\n  color: #333;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\nnav.navbar {\n  margin-bottom: 0;\n}\n\n.navbar-header .navbar-brand {\n  float: left;\n  height: 5rem;\n  padding: 0.5rem 0 0 0;\n  font-size: 1.8rem;\n  cursor: pointer;\n  img {\n    max-height: 100%;\n  }\n}\n\nnav.navbar-inverse {\n  z-index: inherit; /*navbar-static-top*/\n  box-shadow: none; /*layered*/\n  background: none; /*navbar-default*/\n  background-color: none;\n  border: none;\n  .fa {\n    color: #fff;\n  }\n}\n\n.navbar.layered.navbar-default.navbar-static-top {\n  z-index: $navLayer;\n}\n\n#artful-client {\n  .navbar {\n    // height: $navbar-height;\n    position: relative;\n    width: 100%;\n    border: 0;\n    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.12);\n    background-color: rgba(255, 255, 255, 0.7);\n    z-index: $navLayer;\n\n    @media (max-width: $tablet) {\n      background-color: rgba(255, 255, 255, 0.95);\n    }\n\n    .navbar-header {\n      float: none;\n      text-align: center;\n      height: $navbar-height;\n\n      .navbar-brand {\n        height: $navbar-height;\n        float: none;\n        display: inline-block;\n        padding: 0.8rem 0;\n\n        @media (max-width: $tablet) {\n          position: absolute;\n          left: 0.9rem;\n        }\n      }\n\n      .navbar-toggle {\n        float: none;\n        position: absolute;\n        right: 0;\n        top: 0.6rem;\n      }\n\n      .navbar-current {\n        height: $navbar-height;\n        padding: 0.8rem 0;\n        font-size: 2rem;\n        text-transform: uppercase;\n        display: none;\n        align-items: center;\n        justify-content: center;\n\n        @media (max-width: $tablet) {\n          display: flex !important;\n        }\n\n        &__month,\n        &__day {\n          padding-right: 0.5rem;\n          font-weight: 600;\n        }\n      }\n    }\n\n    .navbar-collapse {\n      background: #f8f8f8;\n\n      @media (min-width: $laptop) {\n        position: absolute;\n        top: 0;\n        right: 11.5rem;\n        background: transparent;\n      }\n\n      @media (max-width: 1023px) and (min-width: $mobile) {\n        position: absolute;\n        top: 0;\n        right: 4rem;\n        background: transparent;\n      }\n\n      .navbar-right {\n        margin-right: 0;\n      }\n    }\n\n    .navbar-mobile-calendar {\n      .header-buttons {\n        display: none;\n      }\n\n      .open-date-picker .react-datepicker {\n        border: 0;\n        font-size: 2rem;\n        background: transparent;\n        position: relative;\n        left: 50%;\n        transform: translateX(-50%);\n\n        &__day {\n          font-size: 2rem;\n          width: 1.5em;\n          line-height: 1.5em;\n\n          &:hover {\n            background: transparent;\n            color: black;\n\n            &:before {\n              background: transparent;\n            }\n          }\n        }\n\n        &__header {\n          display: none;\n        }\n\n        &__current-month {\n          font-size: 2rem;\n        }\n\n        &__navigation--next:after,\n        &__navigation--previous:after {\n          padding: 1.6rem;\n        }\n\n        &__navigation--previous {\n          left: -4rem;\n          top: calc(50% - 2.4rem);\n        }\n\n        &__navigation--next {\n          right: -4rem;\n          top: calc(50% - 2.4rem);\n        }\n      }\n    }\n  }\n}\n\n#artful-client .navbar-default .navbar-toggle {\n  border: 0;\n  margin: 0;\n  padding: 1.7rem 0.9rem;\n\n  &:focus,\n  &:hover {\n    background: none;\n    .icon-bar {\n      background-color: $iconColorActive;\n    }\n  }\n\n  .icon-bar {\n    width: 1.8rem;\n    border-radius: 0;\n    height: 0.2rem;\n    background-color: rgba(0, 0, 0, 0.7);\n\n    & + .icon-bar {\n      margin-top: 0.5rem;\n    }\n  }\n}\n\n#artful-client .navbar-nav > li > a {\n  padding-top: 1.5rem;\n  padding-bottom: 1.5rem;\n  height: 5.8rem;\n  line-height: 2.8rem;\n}\n\n#artful-client .navbar-nav .dropdown-toggle:focus {\n  outline: revert;\n}\n\n.artful-plus-new-icon-div {\n  display: inline-block;\n}\n\n.artful-plus-nav-link {\n  display: flex !important;\n}\n\n.artful-plus-new-icon {\n  height: 20px !important;\n  margin-left: 11px;\n  cursor: pointer;\n  position: relative;\n}\n\nsvg#artful-plus-new-icon g path,\nsvg#artful-plus-new-icon path {\n  fill: rgb(171, 58, 114) !important;\n}\n\n.artful-plus-new-text {\n  position: absolute;\n  top: 50%;\n  left: 65%;\n  transform: translate(-50%, -50%);\n  color: white;\n  font-size: 9px;\n  font-weight: 600;\n}\n","$desktop: 1441px;\n$hdlaptop: 1281px;\n$laptop: 1024px;\n$tablet: 768px;\n$mobile: 600px;\n$smobile: 425px;\n\n// Body\n$body-bg: #f5f8fa;\n\n// Borders\n$laravel-border-color: darken($body-bg, 10%);\n$list-group-border: $laravel-border-color;\n$navbar-default-border: $laravel-border-color;\n$panel-default-border: $laravel-border-color;\n$panel-inner-border: $laravel-border-color;\n\n//background\n$background-color: #fff;\n\n$page-min-height: 56rem;\n\n$eventTextSize: 1.1rem;\n\n$headingFontWeight: 200;\n\n// Z-index layers\n$debugLayer: 10000;\n$eventLayer: 100;\n$colorPickerLayer: 200;\n$navLayer: 4000;\n$overEventLayer: 5000;\n$expandedEventLayer: 3500;\n$stickerLayer: 3000;\n$modalOverlayLayer: 5000;\n$modalBaseLayer: 6000;\n$modalConfirmationLayer: 10000;\n$checklistLayer: 500;\n$taskLayer: 500;\n\n$modalConfirmLayer: 6000;\n$modalContentLayer: 10000;\n\n$baseStickerSize: calc((100vw - 34rem - (50vw - 16rem) * 0.25) * 0.05);\n$tabletStickerSize: calc((100vw - 18rem - (50vw - 7rem) * 0.25) * 0.05);\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
